export function displayValue(value: unknown): string {
  if (value === null || value === undefined) return '';
  if (typeof value === 'string') return value;
  if (typeof value === 'number' || typeof value === 'boolean' || typeof value === 'bigint')
    return String(value);
  return JSON.stringify(value);
}
export function requiredValue<T>(value: T): NonNullable<T> {
  if (value === null || value === undefined) throw Error('required_value_missing');
  return value;
}
